import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-check-now-icon",
  "use": "icon-check-now-icon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-check-now-icon\">\n  <path d=\"M947.776 474.496s-180.224 115.2-313.92 306.048L511.36 672.064l-53.312 49.664 211.072 236.288s97.024-262.4 289.984-449.92l-11.328-33.6zM65.088 64.512h124.16v107.904h-124.16V64.512z m197.632 0.256h496.704V172.16H262.72V64.768z m-197.632 320h124.16v107.904h-124.16V384.768z m197.632 0.192h496.704v107.456H262.72V384.96z m-197.632 320.128h124.16v107.904h-124.16v-107.904z m197.632 0.192h142.848v107.456H262.72V705.28z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/selfcheck/check-now-icon.svg
// module id = SWi6
// module chunks = 24